import { apiClient } from "./authService";

export interface StockCreatePayload {
  productId: string;
  businessId?: string;
  qty: number;
}

export interface StockAdjustPayload {
  productId: string;
  businessId?: string;
  qtyDelta: number;
}

export interface StockTransferPayload {
  productId: string;
  fromBusinessId?: string;
  toBusinessId?: string;
  qty: number;
}

// List all stock
export const fetchStock = async (businessId?: string) => {
  const res = await apiClient.get("/stock/list", {
    params: businessId ? { businessId } : {},
  });
  return res.data;
};

// Stock summary (cost/retail/profit)
export const fetchStockSummary = async (businessId?: string) => {
  const res = await apiClient.get("/stock/summary", {
    params: businessId ? { businessId } : {},
  });
  return res.data;
};

// Create or set stock qty
export const createStock = async (payload: StockCreatePayload) => {
  const res = await apiClient.post("/stock/create", payload);
  return res.data;
};

// Adjust stock (positive or negative)
export const adjustStock = async (payload: StockAdjustPayload) => {
  const res = await apiClient.post("/stock/adjust", payload);
  return res.data;
};

// Transfer stock between org/business
export const transferStock = async (
  payload: StockTransferPayload | StockTransferPayload[]
) => {
  const res = await apiClient.post("/stock/transfer", payload);
  return res.data;
};

// Delete stock record (only if qty = 0)
export const deleteStock = async (productId: string, businessId?: string) => {
  if (!productId) throw new Error("productId is required");
  const res = await apiClient.delete("/stock/delete", {
    params: businessId ? { productId, businessId } : { productId },
  });
  return res.data;
};
